module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main main--about"
  }, [_c('div', {
    staticClass: "about__sidebar"
  }, [_c('div', {
    staticClass: "about__menu"
  }, [_c('ul', _vm._l((_vm.menu), function(item, index) {
    return _c('li', {
      key: index,
      class: [{
        'about__menu--active': index === _vm.selected
      }],
      style: ({
        'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
      }),
      on: {
        "click": function($event) {
          return _vm.scrollToDiv(item)
        }
      }
    }, [_vm._v("\n          " + _vm._s(item.label) + "\n        ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "group group--wide group--first"
  }, [_c('div', {
    staticClass: "about"
  }, [_c('div', {
    staticClass: "about__content"
  }, [_c('section', {
    ref: "overview",
    staticClass: "about__header",
    attrs: {
      "id": "overview"
    }
  }, [_c('div', {
    staticClass: "about__intro"
  }, [_c('h1', {
    staticClass: "h1 mt0",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v(_vm._s(_vm.org.program_name) + " connects you with qualified experts who can help")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("\n              Everything in your life affects how you feel. When you’re healthier, you’re happier. When you’ve got friends and family you can count on, you feel less lonely. And when your finances are in order, life isn’t so stressful.\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("We match you with an expert based on your unique situation. You’ll get personalized guidance and helpful advice you can use right away to navigate life events and reach personal goals. All it takes is a single conversation to get things going.")])]), _vm._v(" "), _c('img', {
    staticClass: "about__img hide-below-medium",
    attrs: {
      "src": _vm.images.header,
      "alt": ""
    }
  })]), _vm._v(" "), _c('section', {
    ref: "help",
    attrs: {
      "id": "help"
    }
  }, _vm._l((_vm.aboutSections), function(section, key) {
    return _c('div', {
      key: key,
      staticClass: "about-block"
    }, [_c('div', [_c('div', {
      staticClass: "about-block__header"
    }, [_c('h4', {
      staticClass: "h4 small mt0",
      style: ({
        'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
      }),
      domProps: {
        "innerHTML": _vm._s(section.subtitle)
      }
    }), _vm._v(" "), _c('h2', {
      staticClass: "h2 mt0",
      style: ({
        'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
      }),
      domProps: {
        "innerHTML": _vm._s(section.heading)
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "p mb0",
      domProps: {
        "innerHTML": _vm._s(section.copy)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "about-block__help-list"
    }, [_c('module-help-list', {
      attrs: {
        "items": section.helpList
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "about-block__image"
    }, [(section.image) ? _c('img', {
      staticClass: " about__img",
      attrs: {
        "src": section.image,
        "alt": ""
      }
    }) : _vm._e()]), _vm._v(" "), _c('module-info-list', {
      attrs: {
        "sections": section.iconList,
        "compact": true
      }
    })], 1)
  }), 0)]), _vm._v(" "), _c('div', {
    ref: "thingsToKnow",
    staticClass: "about__things",
    attrs: {
      "id": "thingsToKnow"
    }
  }, [_c('h2', {
    staticClass: "h1",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("Some other things to know about how this works")]), _vm._v(" "), _c('div', {
    staticClass: "about__grid"
  }, _vm._l((_vm.thingsToKnow), function(section, index) {
    return _c('div', {
      key: index,
      staticClass: "things__section"
    }, [_c('h3', {
      staticClass: "h3",
      style: ({
        'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
      })
    }, [_vm._v(_vm._s(section.title))]), _vm._v(" "), _c('p', {
      staticClass: "p"
    }, [_vm._v(_vm._s(section.copy))])])
  }), 0)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1951ed2c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/About.vue
// module id = 550
// module chunks = 0